import React from "react";
import { Box, List, ListItem, Theme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { SxProps } from "@mui/system";
import LinkLegalbird from "@/src/components/legalbird/LinkLegalbird/LinkLegalbird";
import { ArrowDownward } from "@mui/icons-material";

type PageNavigationProps = {
  navigationLinks: Array<{ label: string; target: string }>;
  sx?: SxProps<Theme>;
};

export default function PageNavigation({ navigationLinks, sx }: PageNavigationProps) {
  return (
    <Box sx={sx}>
      <Typography sx={(theme) => ({ color: theme.palette.text.secondary })}>
        <strong>Direkt zu</strong>
      </Typography>
      <List>
        {navigationLinks.map((link) => (
          <ListItem key={link.label} disablePadding sx={{ paddingBottom: "0.75rem" }}>
            <LinkLegalbird to={link.target} standalone>
              {link.label} <ArrowDownward />
            </LinkLegalbird>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
